import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'

Vue.use(Vuex)

const state = {
    dev : "",

    alertModal:{
        alertMsg:"",
        alertTitle:"",
        showAlert:false
    },
    score:0,  //得分 默认为0
    exploreId:1, //用户的exploreid
    visitorId:0,//1064023522,
    gameType:1,


    pass1:0,
    pass2:0,
    pass3:0,
    pass4:0

}

export default new Vuex.Store({
	state,
	actions,
    mutations,
    modules: {
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js